import { Box, Container, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { ErrorOutline } from "@mui/icons-material";
import { routes } from "../routes/routes";

const ForbiddenPage = () => {
  return (
    <Container
      maxWidth="sm"
      sx={{
        height: "70vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box textAlign="center">
        <Box sx={{ mb: 2, color: "error.main" }}>
          <ErrorOutline sx={{ fontSize: 70 }} />
        </Box>
        <Typography variant="h3" fontWeight="bold" gutterBottom>
          Acceso Denegado
        </Typography>
        <Typography variant="body1" mb={3}>
          No tiene permisos para ver esta página.
        </Typography>
        <Button component={Link} to={routes.root} variant="contained" sx={{ mt: 2 }}>
          Volver al inicio
        </Button>
      </Box>
    </Container>
  );
};

export default ForbiddenPage;
